module.exports = __webpack_public_path__ + "media/usp-personalize-96c457f4.svg";